module.exports = __webpack_public_path__ + "img/icon-ft.4af12490.png";